export default "__VITE_ASSET__0jpyl8au__"